import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {Card} from '@jobseeker/lotus/components';
import {Paragraph} from '@jobseeker/lotus/elements';
import {CheckV2} from '@jobseeker/lotus/assets/icons';
import {Image} from '@jobseeker/lotus/components/Image';

const RefundPolicyPage = () => {
  const DOMAIN = `${process.env.NEXT_PUBLIC_APP_DOMAIN}`;
  const HELLO_EMAIL = `hello@${process.env.NEXT_PUBLIC_APP_DOMAIN}`;
  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';
  return isAppIimjobs ? (
    <Box
      sx={{
        maxWidth: '1050px',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Card variant="" heading="">
        <Typography
          sx={{
            fontFamily: 'Poppins',
            fontSize: '24px',
            fontWeight: 500,
            lineHeight: '30px',
            textAlign: 'Center',
            color: 'secondary.dark',
            marginBottom: '40px',
          }}
        >
          REFUND POLICY
        </Typography>
        <Paragraph
          title=""
          body={
            <>
              We have successfully served thousands of happy customers in the
              past and we are confident of the quality of our service. However,
              if you are dissatisfied with any of the paid services on
              {DOMAIN}, please drop us a mail -{' '}
              <Typography
                component={'span'}
                sx={{
                  color: 'primary.main',
                  fontSize: '14px',
                }}
              >
                {HELLO_EMAIL}
              </Typography>{' '}
              and we&apos;ll process the refund. Refunded amount will be
              reflected in your statement in 14 to 21 days.
            </>
          }
        />
        <Paragraph
          title="Cancellation"
          body={
            <>
              If you upgraded to the Pro Plan by mistake, please drop us a mail
              at{' '}
              <Typography
                component={'span'}
                sx={{
                  color: 'primary.main',
                  fontSize: '14px',
                }}
              >
                {HELLO_EMAIL}
              </Typography>{' '}
              within one day from the upgrade. We will cancel your
              pro-membership and refund the amount.
            </>
          }
        />
      </Card>
    </Box>
  ) : (
    <Box
      sx={{
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: {xxs: '12px 10px', md: '40px 50px'},
      }}
    >
      <Card
        variant=""
        heading=""
        sx={{
          minHeight: {xxs: 'calc(100vh - 174px)', md: 'calc(100vh - 280px)'},
          padding: '20px',
        }}
      >
        <Typography
          sx={{
            fontSize: {xxs: '16px', md: '18px'},
            fontWeight: 700,
            lineHeight: '30px',
            // textAlign: 'Center',
            color: '#000',
            marginBottom: {xxs: '7px', md: '16px'},
          }}
        >
          What is your refund policy?
        </Typography>
        <Box display={'flex'} justifyContent={'flex-start'}>
          <Box
            component={Image}
            src={CheckV2}
            width={20}
            height={20}
            alt="Check"
          />
          <Box marginLeft={'10px'}>
            <Paragraph
              title=""
              body={
                <>
                  <Typography fontSize={'15px'} color={'#525252'}>
                    We have successfully served thousands of happy customers in
                    the past and we are confident of the quality of our service.
                  </Typography>
                  <Typography
                    fontSize={'15px'}
                    marginTop={'9px'}
                    color={'#525252'}
                  >
                    However, if you are dissatisfied with any of the paid
                    services on
                    {DOMAIN}, please drop us a mail -{' '}
                    <Typography
                      component={'span'}
                      sx={{
                        color: 'primary.main',
                        fontSize: '14px',
                      }}
                    >
                      {HELLO_EMAIL}
                    </Typography>{' '}
                    and we&apos;ll process the refund. Refunded amount will be
                    reflected in your statement in 14 to 21 days.
                  </Typography>
                </>
              }
            />
            <Paragraph
              title="Cancellation:"
              titleStyle={{
                fontWeight: 700,
                color: '#525252',
              }}
              body={
                <Typography color={'#525252'} fontSize={'15px'}>
                  If you upgraded to the Pro Plan by mistake, please drop us a
                  mail at{' '}
                  <Typography
                    component={'span'}
                    sx={{
                      color: 'primary.main',
                      fontSize: '14px',
                    }}
                  >
                    {HELLO_EMAIL}
                  </Typography>{' '}
                  within one day from the upgrade. We will cancel your
                  pro-membership and refund the amount.
                </Typography>
              }
            />
          </Box>
        </Box>
      </Card>
    </Box>
  );
};

export default RefundPolicyPage;
